import { render, staticRenderFns } from "./writeinspectionrecords.vue?vue&type=template&id=505150f0&scoped=true&"
import script from "./writeinspectionrecords.vue?vue&type=script&lang=js&"
export * from "./writeinspectionrecords.vue?vue&type=script&lang=js&"
import style0 from "./writeinspectionrecords.vue?vue&type=style&index=0&id=505150f0&lang=scss&scoped=true&"
import style1 from "./writeinspectionrecords.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505150f0",
  null
  
)

export default component.exports